/*
 * Smores "Complete Your Kit" upsell
 *
 * Each .smores-kit-card has a per-card Add button (single-item form
 * submit). The combined "Add All to Cart" button POSTs all selected
 * items in one shot using Shopify's /cart/add.js multi-item endpoint,
 * then redirects to /cart so the user sees the merged state.
 *
 * Selection model: every card is selected by default. Clicking a per-
 * card "Add" toggles its inclusion in the combined total.
 */

(() => {
  const cardSelector = '.smores-kit-card';
  const totalAmountEl = document.querySelector('[data-kit-total-amount]');
  const addAllBtn = document.querySelector('[data-kit-add-all]');

  if (!addAllBtn) return;

  const cards = [...document.querySelectorAll(cardSelector)];

  const moneyFormat = addAllBtn.dataset.moneyFormat;
  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  };

  const recalc = () => {
    const total = cards
      .filter((c) => c.dataset.selected === 'true')
      .reduce((sum, c) => sum + parseInt(c.dataset.price || '0', 10), 0);
    if (totalAmountEl) totalAmountEl.textContent = formatMoney(total);
  };

  // Per-card Add button toggles selection (instead of immediately adding)
  cards.forEach((card) => {
    const addBtn = card.querySelector('[data-kit-toggle]');
    if (!addBtn) return;
    addBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const selected = card.dataset.selected !== 'false';
      card.dataset.selected = String(!selected);
      addBtn.querySelector('[data-kit-toggle-text]').textContent = selected ? 'Add' : 'Added';
      recalc();
    });
  });

  // Add all selected to cart via /cart/add.js
  addAllBtn.addEventListener('click', async (e) => {
    e.preventDefault();
    const items = cards
      .filter((c) => c.dataset.selected !== 'false' && c.dataset.variantId)
      .map((c) => ({ id: parseInt(c.dataset.variantId, 10), quantity: 1 }));

    if (items.length === 0) return;

    addAllBtn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) throw new Error('Cart add failed');
      addAllBtn.disabled = false;
      // Open the side cart instead of navigating away
      if (window.SmoresCart) { await window.SmoresCart.refresh(); window.SmoresCart.open(); }
      else document.dispatchEvent(new Event('smores:cart:refresh'));
    } catch (err) {
      console.error('[smores-kit] add-all failed', err);
      addAllBtn.disabled = false;
    }
  });

  recalc();
})();
